import { render } from "./EditAdmin.vue?vue&type=template&id=1b90e5e4&scoped=true"
import script from "./EditAdmin.vue?vue&type=script&lang=js"
export * from "./EditAdmin.vue?vue&type=script&lang=js"

import "./EditAdmin.vue?vue&type=style&index=0&id=1b90e5e4&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b90e5e4"]])

export default __exports__